import { render, staticRenderFns } from "./my-table.vue?vue&type=template&id=8b7f5dd8&scoped=true&"
import script from "./my-table.vue?vue&type=script&lang=js&"
export * from "./my-table.vue?vue&type=script&lang=js&"
import style0 from "./my-table.vue?vue&type=style&index=0&id=8b7f5dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7f5dd8",
  null
  
)

export default component.exports